import React from "react";

import "./style.scss";

export interface Props {
    small?: boolean;
    visible?: boolean;
}

/**
 * The loading indicator can be displayed when a component is waiting for data to be displayed. The indicator will
 * position itself absolutely and centered in its parent container.
 * To achieve a fade in/out animation, the component should always be rendered and only its `visible` prop should be updated.
 */
export const LoadingIndicator = ({ small = false, visible }: Props) => {
    const [doRender, setDoRender] = React.useState(false);
    const classNames = ["loadingIndicator"];

    if (small) {
        classNames.push("small");
    }

    React.useEffect(() => {
        setDoRender(true);
    }, []);

    if (!doRender) {
        return null;
    }

    if (visible === true) {
        classNames.push("visible");
    }

    return <div className={classNames.join(" ")} />;
};
